import { lang, correlationFields } from "../core/variables-global.js";
import { config } from "../core/config.js";
import UIHelper from "./UIHelper.js";
import initSimpleSearch from "../search/simpleSearch.js";

let helpers = () => {

  function showLoading(show) {
      console.log(`${show ? "Affichage" : "Masquage"} du spinner de chargement pour la recherche simple`);
      const elements = [searchInput, searchButton, reloadButton];
      UIHelper.setElementsDisabled(elements, show);
    }


  function formatCurrency(amont) {
    return new Intl.NumberFormat(`${lang}-CA`, {
      style: "currency",
      currency: "CAD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(amont);
  }

  function formatThousand(number) {
    number = number.toString().replace(",0", "");//Nettoyage obligatoire pour les données venant de GMI
    return new Intl.NumberFormat(`${lang}-CA`, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(number);
  }

  // Fonction de corrélation entre les champs
  const correlateFields = (field, model) => {
   // console.log(`Recherche de la corrélation pour le champ ${field} dans le modèle ${model}`);
    let fieldArray = correlationFields.filter(subArray => subArray.includes(field));
    let nField = (model === "es") ? fieldArray[0][1] : fieldArray[0][0];
   /// console.log(`Champ corrélé pour ${field} dans le modèle ${model} : ${nField}`);
    return nField;
  }

  const forcedChoice = async () => {

    const urlParams = new URLSearchParams(window.location.search);
    /**
     * Retrieves the 'liste' parameter value from the URL query string.
     * @type {string|null} The value of the 'liste' parameter, or null if not present in the URL
     */
    const listeParam = urlParams.get('liste');
    /**
     * Retrieves the optional 'tp' parameter value from the URL query string.
     * S'ajoute au paramètre 'liste'. Lorsque sa valeur est '1', la case à cocher
     * des thermopompes admissibles à la bonification est cochée automatiquement.
     * @type {string|null} The value of the 'tp' parameter, or null if not present in the URL
     */
    const tpParam = urlParams.get('tp');

    if (listeParam) {
      config.fromURLParam = true;
      const datePicker = document.querySelector('.js-date-picker');

      if (datePicker) {
        datePicker.value = new Date().toISOString().split('T')[0];
      }
      // Sécurisation : recherche par valeur d'attribut plutôt que par sélecteur interpolé
      const radioInputs = document.querySelectorAll('input[type="radio"]');
      const radioInput = Array.from(radioInputs).find(input => input.value === listeParam);

      if (radioInput) {
        radioInput.checked = true;
        radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (window.listPickerInstance && typeof window.listPickerInstance.handleFormSubmit === 'function') {
        // Clic automatique sur le bouton de soumission du formulaire
        window.listPickerInstance.handleFormSubmit();
        // Attendre que l'événement dataReady soit déclenché

        const handleDataReady = () => {
          console.log("Données prêtes, ouverture des filtres...");

          document.querySelector(".js-checkbox_puissance_nominale").checked = true;

          if (tpParam === '1') {
            const checkboxBonification = document.querySelector(".js-checkbox_admissible_bonification");
            if (checkboxBonification) {
              checkboxBonification.checked = true;
            }
          }

          document.querySelector('.js-button-filtres')?.click();
          // Retirer l'écouteur après utilisation
          //window.IndexedDBManager.removeEventListener('dataReady', handleDataReady);

          const elements = [initSimpleSearch.searchInput, initSimpleSearch.searchButton, initSimpleSearch.reloadButton];
          UIHelper.setElementsDisabled(elements, false);
        };

        // Vérifier si les données sont déjà prêtes
        if (window.IndexedDBManager && window.IndexedDBManager.isDataReady) {
          console.log("Données déjà prêtes, ouverture immédiate des ..filtres.");
          document.querySelector('.js-button-filtres')?.click();

        } else if (window.IndexedDBManager) {
          // Sinon, attendre l'événement via le système d'événements personnalisé d'IndexedDBManager
          console.log("Attente des données pour ouvrir les filtres...");
          window.IndexedDBManager.addEventListener('dataReady', handleDataReady);
        }

      } else {
        console.warn("L'instance de listPicker n'est pas encore initialisée");
      }
    }
  }

  return {
    showLoading,
    formatCurrency,
    formatThousand,
    correlateFields,
    forcedChoice
  };
}

helpers = helpers();
export default helpers;
